import React from 'react';
import { Chip, ChipProps } from '@mui/material';

export interface RemoteOriginChipProps {
  /** Source location / warehouse name */
  locationName: string | null | undefined;
  size?: ChipProps['size'];
  sx?: ChipProps['sx'];
}

/**
 * Yellow badge marking pieces sourced from another branch or warehouse.
 * Keep this visual consistent across the entire Nueva Venta flow.
 */
const RemoteOriginChip: React.FC<RemoteOriginChipProps> = ({
  locationName,
  size = 'small',
  sx,
}) => {
  if (!locationName) return null;

  return (
    <Chip
      label={`Origen: ${locationName}`}
      size={size}
      color="warning"
      variant="outlined"
      sx={[{ height: 20, fontSize: '0.7rem' }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
    />
  );
};

export default RemoteOriginChip;
